import {
	type PartnerBankAccountUpdateDto,
	patchPartnersPartnerIdBankAccountsId,
} from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const partnerMutationsResource = Resources.base.partner.mutations;

export const useUpdateBankAccount = (partnerId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (args: { data: PartnerBankAccountUpdateDto; id: number }) =>
			patchPartnersPartnerIdBankAccountsId(args.data, partnerId, args.id),
		onError: (error) => {
			console.error(
				`${t(partnerMutationsResource.partnerBankAccountUpdateError)}:`,
				error,
			);
		},
		onSuccess: () => {
			toast.success(
				t(partnerMutationsResource.partnerBankAccountUpdateSuccess),
			);
			queryClient.invalidateQueries({
				queryKey: ["PARTNER_DETAIL", partnerId],
			});
		},
	});
};
